import React from "react";

import {trans, getCookie, removeCookie} from "../../../../common/utils";
import {CountdownTimer} from "../../../../common/hooks";

const ForgotPassForbidden = ({setFormPart}) => {
    const sec = parseInt(getCookie('forgot-forbidden'));

    return <p className="simple-signup__text">{trans("You can try again in")}: {CountdownTimer({
        sec: sec ?? 900, onOver: () => {
            removeCookie('forgot-forbidden');
            setFormPart(1);
        }
    })}</p>
};

export default ForgotPassForbidden;

